import React, {Component, ReactNode} from "react"
import styled from "styled-components"
import {Dropdown} from "react-bootstrap"
import authentication from "@irati/auth"
import id from "@irati/utils/id"
import {IconButton} from "@irati/ui/src/Button"
import wasCreatedBy from "@irati/recognition/utils/wasCreatedBy"
import {EditableContent} from "@irati/recognition/enums/Moderation"

export interface RenderPropArgs {
  item: EditableContent
  isUserContent: boolean
  canDeletePoll: boolean
  isAdmin: boolean
}

export interface MenuActionsProps extends Partial<Dropdown.DropdownBaseProps> {
  item: EditableContent
  children: (args: RenderPropArgs) => ReactNode[]
}

const Toggle = styled(IconButton)`
  color: ${({theme}) => theme.colors.greys.medium};
`

class MenuActions extends Component<MenuActionsProps> {
  static defaultProps = {
    id: "menu-actions"
  }

  render() {
    const {item, children, ...props} = this.props
    const user = authentication.user()
    const isAdmin = authentication.isGlobalAdmin()
    const isUserContent = !item ? false : wasCreatedBy(item, user)
    const canDeletePoll = !!authentication.apps("recognition.poll.delete")

    let entries = children({
      item,
      isUserContent,
      canDeletePoll,
      isAdmin
    })

    if (!Array.isArray(entries)) {
      entries = [entries]
    }

    entries = entries.filter((entry) => entry)

    const isHidden = entries.length === 0

    if (isHidden) {
      return null
    }

    return (
      <Dropdown {...props} id={id("button", this.props)}>
        <Toggle icon="ellipsis" bsRole="toggle" />
        <Dropdown.Menu>{entries}</Dropdown.Menu>
      </Dropdown>
    )
  }
}

export default MenuActions
